/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addSubMenuID } from '~/store/modules/SubMenu/actions';
import { Container } from '~/styles/pagesStyle';
import { handleDeleteSubMenu, handleUpdateSubMenu } from '../SubMenuServices';
import Card from './Card';

const initialForm = {
  idSituacaoCadastral: '',
  nome: '',
  descricao: '',
  url: '',
  parent: '',
  nomeImagem: '',
  ordem: '',
  tipoPagina: '',
  idRelatorio: '',
};

function SubMenuUpdate() {
  const [form, setForm] = useState(initialForm);
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [subMenuData, setSubMenuData] = useState({});
  const [loading, setLoading] = useState(false);
  const usuarioLogado = sessionStorage.getItem('@auth/userName');

  useEffect(() => {
    setLoading(true);
    async function getData() {
      dispatch(addSubMenuID(id));
      await api
        .get(`/MenuSub/${id}`)
        .then((response) => {
          setSubMenuData(response.data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          toast.error(
            'Erro ao buscar informações do sub menu, tente novamente'
          );
          history.goBack();
        });
    }
    getData();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const subMenu = {
      id: parseInt(id),
      idMenu: subMenuData.iD_MENU,
      idSituacaoCadastral:
        form.idSituacaoCadastral || subMenuData.iD_SITUACAO_CADASTRAL,
      idPagina: null,
      nome: form.nome || subMenuData.nome,
      descricao: form.descricao || subMenuData.descricao,
      url: form.tipoPagina === 'O' ? form.url : null,
      parent: subMenuData.parent || null,
      nomeImagem: form.nomeImagem || null,
      ordem: form.ordem || subMenuData.ordem,
      tipoPagina: form.tipoPagina || subMenuData.tipO_PAGINA,
      numeroGrid: 0,
      idRelatorio: form.idRelatoriorelatorio || subMenuData.iD_RELATORIO,
      dataInclusao: null,
      usuario: usuarioLogado,
      excluido: false,
    };
    await handleUpdateSubMenu(subMenu, setLoading);
    history.push('/menu-sub/list');
  }

  async function handleDelete() {
    await handleDeleteSubMenu(setLoading);
    history.push('/menu-sub/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner style={{ width: '3rem', height: '3rem', margin: '5% auto' }} />
      ) : (
        <Card
          subMenuData={subMenuData}
          setForm={setForm}
          form={form}
          loading={loading}
          handleSubmit={handleSubmit}
          handleDelete={handleDelete}
        />
      )}
    </Container>
  );
}

export default SubMenuUpdate;
